import Button from '../../../../Components/Button/Button';
import React, { useState } from 'react';
import { ToothEndodontic } from '../../../../graphql/graphql';
import useTranslation from '../../../../Hooks/useTranslation';
import { useDENTContext } from '../../Services/DENTContext';
import DENTToothQuickEndodonticModalButtons from './DENTToothQuickEndodonticModalButtons';
import styles from './DENTToothQuickEndodonticModal.module.scss';

const DENTToothQuickEndodonticModal = () => {
	const { t } = useTranslation();
	const [values, setValues] = useState<ToothEndodontic>({});
	const { handleUpdateToothBulk } = useDENTContext();

	const handleSubmit = async () => {
		handleUpdateToothBulk({
			endodontic: values,
		});
	};

	return (
		<>
			<h2>{t('patientTreatment.meddiDENT.dentalCross.endodontic.title')}</h2>
			<DENTToothQuickEndodonticModalButtons
				values={values}
				setValues={setValues}
			/>
			<Button
				className={styles.button}
				title={'base.shared.form.send'}
				onClick={handleSubmit}
			/>
		</>
	);
};

export default DENTToothQuickEndodonticModal;
